import React from 'react';
import { methodology } from '../data/mockData';

const Methodology = () => {
  return (
    <section 
      id="methodology" 
      className="py-24"
      style={{ backgroundColor: '#f8f9fa' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 
            className="text-4xl font-bold mb-4"
            style={{ color: '#3B3838' }}
          >
            Nuestra Metodología
          </h2>
          <p 
            className="text-lg"
            style={{ color: '#6B7280' }}
          >
            Un proceso de 5 pasos que garantiza precisión y efectividad comprobada. 
            Elevamos la limpieza a la categoría de ciencia.
          </p>
        </div>

        {/* Methodology Steps - Alternating Layout */}
        <div className="space-y-16">
          {methodology.map((step, index) => {
            const isEven = index % 2 === 0;
            
            return (
              <div 
                key={step.step}
                className={`grid lg:grid-cols-2 gap-8 lg:gap-12 items-center ${
                  isEven ? '' : 'lg:grid-flow-dense'
                }`}
              >
                {/* Image */}
                <div 
                  className={`${isEven ? '' : 'lg:col-start-2'} relative group`}
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    {/* Overlay gradient */}
                    <div 
                      className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      style={{
                        background: 'linear-gradient(to top, rgba(46, 117, 182, 0.3), transparent)'
                      }}
                    />
                  </div>
                  
                  {/* Step number badge */}
                  <div 
                    className="absolute -top-6 -left-6 w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold shadow-2xl"
                    style={{ 
                      backgroundColor: '#2E75B6',
                      color: 'white'
                    }}
                  >
                    {step.step}
                  </div>
                </div>

                {/* Content */}
                <div className={`${isEven ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                  <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                    {/* Step indicator */}
                    <div 
                      className="inline-block px-4 py-1 rounded-full text-sm font-semibold mb-4"
                      style={{ 
                        backgroundColor: '#FFF3CD',
                        color: '#FFC000'
                      }}
                    >
                      Paso {step.step} de 5
                    </div>
                    
                    <h3 
                      className="text-2xl lg:text-3xl font-bold mb-4"
                      style={{ color: '#3B3838' }}
                    >
                      {step.title}
                    </h3>
                    
                    <p 
                      className="text-lg leading-relaxed"
                      style={{ color: '#6B7280' }}
                    >
                      {step.description}
                    </p>

                    {/* Decorative line */}
                    <div 
                      className="mt-6 h-1 w-20 rounded-full"
                      style={{ backgroundColor: '#2E75B6' }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Emphasis */}
        <div 
          className="mt-20 max-w-4xl mx-auto text-center p-10 rounded-2xl"
          style={{ 
            background: 'linear-gradient(135deg, #2E75B6 0%, #7030A0 100%)'
          }}
        >
          <h3 className="text-3xl font-bold text-white mb-4">
            Compromiso con la Excelencia
          </h3>
          <p className="text-white/90 text-lg leading-relaxed">
            Cada paso de nuestro proceso está diseñado para superar sus expectativas 
            y garantizar resultados impecables en cada intervención. Nuestro equipo 
            altamente capacitado asegura la máxima calidad en cada etapa.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
